
const breakdownRecoveryImg = require('../icons/breakdown_recovery.JPG');
const vanRecoveryImg = require('../icons/van_recovery.WEBP');
const emergencyRecoveryImg = require('../icons/emergency_recovery.jpg');
const motorwayRecoveryImg = require('../icons/motorway_recovery.png');
const motorbikeRecoveryImg = require('../icons/motorbike_recovery.jpg');

export interface Service {
    slug: string;
    title: string;
    description: string;
    longDescription: string;
    image: string;
    benefits: string[];
    process: { step: string; detail: string }[];
    faqs: { q: string; a: string }[];
}

export const services: Service[] = [
    {
        slug: 'breakdown-recovery',
        title: 'Breakdown Recovery',
        description: 'Professional 24/7 breakdown recovery services in Birmingham and West Midlands. Fast, safe, and reliable assistance whenever you need it.',
        longDescription: `When your vehicle suddenly breaks down, the situation can be stressful, inconvenient, and sometimes dangerous — especially on busy roads or motorways. Cheapest Car Recovery provides professional 24/7 breakdown recovery services in Birmingham and across the West Midlands, ensuring you get fast, safe, and reliable assistance whenever you need it.

If you’re searching online for "car recovery near me" or "car recovery service near me", our local team is always ready to reach you quickly and get you moving again.

Whether your car refuses to start, breaks down while driving, or develops a mechanical fault, our experienced recovery team is always ready to respond. We recover vehicles from homes, streets, car parks, and major motorways, transporting them safely to your home, garage, or preferred location.

### Professional Breakdown Recovery You Can Trust
Cheapest Car Recovery specializes in emergency breakdown recovery for cars, vans, and light commercial vehicles. Our fully equipped recovery trucks and trained operators ensure your vehicle is handled with care at every stage.

Our breakdown recovery service includes:
• 24/7 emergency assistance
• Local and long-distance recovery
• Motorway and roadside breakdown recovery
• Safe vehicle loading and transportation
• Drop-off to home, garage, or repair centre

No matter the time of day or night, we are committed to getting you and your vehicle to safety quickly.

### When Do You Need Breakdown Recovery?
You may need professional breakdown recovery if:
• Your vehicle suddenly stops running
• The engine fails or overheats
• Warning lights indicate a serious fault
• Your car won’t start due to mechanical issues
• You break down on a motorway or busy road

Driving a faulty vehicle can make the situation worse. Calling Cheapest Car Recovery ensures the problem is handled safely and professionally.

### Breakdown Recovery Across Birmingham & West Midlands
We proudly offer fast-response breakdown recovery across:
• Birmingham
• Sheldon
• Dudley
• Walsall
• Coventry
• Wolverhampton

We also provide motorway breakdown recovery on:
• M6
• M5
• M42
• M40

Our local knowledge allows us to reach you quickly and avoid unnecessary delays.

### Why Choose Cheapest Car Recovery?
Choosing the right recovery service matters. At Cheapest Car Recovery, we focus on reliability, safety, and customer satisfaction.

• Fast response times
• Competitive and transparent pricing
• Experienced and professional recovery drivers
• Modern recovery vehicles
• 24/7 availability, including weekends and holidays

We understand breakdowns don’t follow schedules — that’s why we’re always available.

### Affordable & Reliable Emergency Breakdown Assistance
We believe breakdown recovery should be professional and affordable. Our pricing is fair and transparent, with no hidden charges. Whether it’s a short local recovery or a longer-distance transport, you’ll receive a clear and honest service every time.

If you’re searching for “breakdown recovery near me”, “24 hour breakdown recovery Birmingham”, or “emergency vehicle recovery West Midlands”, Cheapest Car Recovery is the trusted local choice.

### Call Us for Immediate Breakdown Recovery
If your vehicle has broken down, don’t wait or risk further damage. Contact Cheapest Car Recovery now for fast and professional breakdown recovery.`,
        image: breakdownRecoveryImg,
        benefits: [
            '24/7 Emergency Assistance',
            'Birmingham & West Midlands',
            'Cars, Vans & Light Vehicles',
            'Fast Response Times',
            'Competitive Pricing'
        ],
        process: [
            { step: 'Contact Us', detail: 'Call our 24/7 hotline immediately for assistance.' },
            { step: 'Rapid Deployment', detail: 'Our local team is dispatched to your location in Birmingham or West Midlands.' },
            { step: 'Safe Recovery', detail: 'We transport your vehicle safely to your home, garage, or destination.' }
        ],
        faqs: [
            { q: 'How quickly can you reach me?', a: 'We aim for fast response times depending on traffic and location, especially within Birmingham and nearby areas.' },
            { q: 'Do you recover vehicles from motorways?', a: 'Yes, we provide safe and professional motorway breakdown recovery on M6, M5, M42, and surrounding routes.' },
            { q: 'Are you available 24/7?', a: 'Yes, our breakdown recovery service operates 24 hours a day, 7 days a week.' },
            { q: 'Can you recover vans as well as cars?', a: 'Yes, we recover cars, vans, and light commercial vehicles.' }
        ]
    },
    {
        slug: 'accident-recovery',
        title: 'Accident Recovery',
        description: 'Professional 24/7 accident recovery services across Birmingham and the West Midlands, ensuring your vehicle is recovered safely and efficiently.',
        longDescription: `Being involved in a road accident can be a distressing experience, whether it’s a minor collision or a serious incident. At times like these, you need a recovery service you can rely on. Cheapest Car Recovery provides professional 24/7 accident recovery services across Birmingham and the West Midlands, ensuring your vehicle is recovered safely and efficiently.

If you’re searching for "car recovery near me" or "car recovery service near me" after an accident, our experienced team is ready to respond fast and assist you right away.

Our trained recovery team handles accident situations with care, professionalism, and urgency. From busy city roads to high-speed motorways, we ensure your vehicle is removed safely and transported to your chosen destination with minimal disruption.

### Professional Accident Recovery You Can Depend On
Cheapest Car Recovery specializes in emergency accident recovery for cars, vans, and light commercial vehicles. Our modern recovery vehicles are fully equipped to deal with damaged or non-drivable vehicles, ensuring safe loading and transport at all times.

Our accident recovery service includes:
• 24/7 emergency response
• Recovery from road traffic accidents
• Safe removal of damaged vehicles
• Motorway and roadside accident recovery
• Transportation to home, garage, or insurance-approved location

No matter the severity of the accident, our priority is safety — yours and your vehicle’s.

### When Do You Need Accident Recovery?
You may require accident recovery if:
• Your vehicle has been involved in a collision
• The car is not safe or legal to drive
• Airbags have deployed or body damage is severe
• The vehicle is immobilised after an accident
• The police or authorities request vehicle removal

Attempting to drive a damaged vehicle can be dangerous. Professional accident recovery ensures safe and legal handling of the situation.

### Accident Recovery Across Birmingham & West Midlands
We provide fast accident recovery coverage throughout:
• Wolverhampton
• West Bromwich
• Solihull
• Tamworth
• Nuneaton
• Hinckley

We also offer motorway accident recovery services on:
• M6
• M5
• M42
• M40

Our local knowledge allows us to reach accident locations quickly and manage recoveries efficiently.

### Why Choose Cheapest Car Recovery for Accident Recovery?
When dealing with an accident, choosing the right recovery company matters.

• Rapid response in emergency situations
• Fully trained and experienced recovery drivers
• Safe handling of accident-damaged vehicles
• Competitive and transparent pricing
• 24/7 availability across Birmingham & West Midlands

Cheapest Car Recovery is committed to providing calm, professional support when you need it most.

### Safe & Reliable Emergency Accident Assistance
We understand that accidents can be unexpected and overwhelming. That’s why Cheapest Car Recovery focuses on clear communication, careful vehicle handling, and reliable service from the moment you contact us.

If you’re searching for “accident recovery near me”, “car accident recovery Birmingham”, or “24 hour accident recovery West Midlands”, Cheapest Car Recovery is the trusted local choice.

### Call Us for Immediate Accident Recovery
If you’ve been involved in an accident, don’t take unnecessary risks. Contact Cheapest Car Recovery immediately for professional accident recovery services.`,
        image: 'https://i.pinimg.com/736x/5a/33/8e/5a338e5da520809307f4b73c41f41403.jpg',
        benefits: [
            '24/7 Emergency Response',
            'Road Traffic Accidents',
            'Safe Vehicle Removal',
            'Motorway Recovery',
            'Insurance Approved Transport'
        ],
        process: [
            { step: 'Contact Us', detail: 'Call our 24/7 hotline immediately. Coverage across Birmingham & West Midlands.' },
            { step: 'Safe Removal', detail: 'Our trained team safely retrieves your damaged vehicle from the road or motorway.' },
            { step: 'Secure Transport', detail: 'We transport your vehicle to your home, garage, or insurance-approved location.' }
        ],
        faqs: [
            { q: 'Do you provide 24/7 accident recovery?', a: 'Yes, our accident recovery service operates 24 hours a day, 7 days a week.' },
            { q: 'Can you recover vehicles from motorways after accidents?', a: 'Yes, we recover accident-damaged vehicles from M6, M5, M42, and surrounding routes.' },
            { q: 'Can you take my vehicle to a garage?', a: 'Yes, we transport vehicles to your preferred destination or insurance-approved location.' },
            { q: 'Do you recover vans as well as cars?', a: 'Yes, we recover cars, vans, and light commercial vehicles.' }
        ]
    },
    {
        slug: 'emergency-recovery',
        title: 'Emergency Recovery',
        description: 'Vehicle emergencies can happen at any time. We provide 24/7 emergency vehicle recovery services in Birmingham and across the West Midlands.',
        longDescription: `Vehicle emergencies can happen at any time — late at night, during bad weather, or on busy roads. Cheapest Car Recovery provides 24/7 emergency vehicle recovery services in Birmingham and across the West Midlands, ensuring fast and reliable assistance whenever you need it.

If you’re searching for "car recovery near me" or "car recovery service near me" after an accident, our experienced team is ready to respond fast and assist you right away.

Whether you’ve broken down suddenly, been involved in an accident, or feel unsafe where your vehicle has stopped, our emergency recovery team is ready to respond quickly and professionally.

### Professional Emergency Recovery You Can Trust
Cheapest Car Recovery specialises in urgent roadside and vehicle recovery services. Our fully equipped recovery trucks and experienced drivers ensure safe vehicle transportation at all times.

Our emergency recovery service includes:
• Immediate breakdown assistance
• Accident recovery
• Roadside recovery
• Emergency towing
• Transport to home or garage

We prioritise your safety and aim to get you and your vehicle off the road as quickly as possible.

### When Do You Need Emergency Recovery?
You may need emergency recovery if:
• Your vehicle breaks down suddenly
• You are involved in a collision
• Your car stops in a dangerous location
• You experience severe mechanical failure
• You break down late at night

Driving a damaged or faulty vehicle can increase risk. Calling Cheapest Car Recovery ensures safe and immediate assistance.

### Emergency Recovery Across Birmingham & West Midlands
We provide rapid emergency recovery across:
• Halesowen
• Stechford
• Telford
• West Bromwich
• Bristol
• Northampton

We also cover motorway emergencies on:
• M6
• M5
• M40
• M42

### Why Choose Cheapest Car Recovery for Emergency Recovery?
• 24/7 rapid response
• Competitive pricing
• Experienced recovery professionals
• Modern recovery vehicles
• Safe and reliable transport

Emergencies require quick action — and we are always ready.

### Call Us for Immediate Assistance
If you need urgent vehicle recovery, contact Cheapest Car Recovery now.`,
        image: emergencyRecoveryImg,
        benefits: [
            '24/7 Rapid Response',
            'Safe Transport',
            'Experienced Professionals',
            'Modern Fleet',
            'Competitive Pricing'
        ],
        process: [
            { step: 'Contact Us', detail: 'Call our 24/7 hotline for immediate emergency assistance.' },
            { step: 'Rapid Dispatch', detail: 'Our nearest recovery unit is sent to your location immediately.' },
            { step: 'Safe Recovery', detail: 'We secure your vehicle and transport you to safety.' }
        ],
        faqs: [
            { q: 'Do you provide 24/7 emergency recovery?', a: 'Yes, we operate around the clock to assist with breakdowns and emergencies.' },
            { q: 'Can you recover large commercial vans?', a: 'Yes, we recover all types of vans, including panel and commercial vehicles.' },
            { q: 'Do you cover motorways?', a: 'Yes, our van recovery service covers M6, M5, M42, and surrounding routes.' },
            { q: 'Can you transport vans to garages or business locations?', a: 'Absolutely — we deliver safely to your preferred destination.' }
        ]
    },
    {
        slug: 'van-recovery',
        title: 'Van Recovery',
        description: 'Professional van recovery services across Birmingham and West Midlands. We handle small and large commercial vehicles safely and efficiently.',
        longDescription: `When a van breaks down, whether it’s for work or personal use, it can cause significant delays and disruptions. Cheapest Car Recovery provides professional van recovery services across Birmingham and the West Midlands, ensuring your van is recovered safely and quickly so you can get back on schedule.

If you’re searching for "car recovery near me" or "car recovery service near me" because of a puncture or blowout, our local team can reach you fast and sort the problem on the spot.

Our team specialises in handling all types of vans, from small panel vans to larger commercial vehicles, providing reliable recovery services in both urban areas and on major motorways.

### Professional Van Recovery You Can Trust
With Cheapest Car Recovery, van breakdowns are handled with care and efficiency. Our experienced drivers use specialised recovery equipment to transport your van safely without causing damage.

Our van recovery service includes:
• 24/7 emergency van recovery
• Safe loading and transportation of all types of vans
• Local, long-distance, and motorway recovery
• Recovery from breakdowns, accidents, or mechanical faults
• Delivery to home, garage, or business location

No matter the situation, we ensure your van is recovered professionally and safely.

### When Do You Need Van Recovery?
You may require professional van recovery if:
• Your van has broken down on the road
• Mechanical failure prevents safe driving
• You’ve been involved in a minor accident
• Your van is immobilised on a busy road or motorway

Attempting to move a broken-down van without professional support can be dangerous. Professional van recovery ensures safety and efficiency.

### Van Recovery Across Birmingham & West Midlands
We provide rapid van recovery services across:
• Cannock
• Worcester
• Gloucester
• Cheltenham
• Nuneaton
• Lichfield

We also cover motorway recovery on:
• M6
• M5
• M42
• M40

With local knowledge and modern recovery equipment, we reach your van quickly and handle it safely.

### Why Choose Cheapest Car Recovery for Van Recovery?
Choosing the right recovery service is crucial to avoid damage and delays.

• 24/7 availability for van recovery emergencies
• Trained and professional drivers
• Safe handling of all types of vans
• Transparent and affordable pricing
• Local expertise across Birmingham & West Midlands

Cheapest Car Recovery is committed to providing reliable van recovery whenever you need it most.

### Affordable & Reliable Van Recovery
Van breakdowns can disrupt your work or schedule. Our cost-effective van recovery solutions ensure fast, safe, and professional transport to your desired destination.

If you’re searching for “van recovery near me”, “emergency van towing Birmingham”, or “van breakdown recovery West Midlands”, Cheapest Car Recovery is the trusted local choice.

### Call Us for Van Recovery
Don’t let a van breakdown stop your day. Contact Cheapest Car Recovery now for fast and professional van recovery services.`,
        image: vanRecoveryImg,
        benefits: [
            '24/7 Van Recovery',
            'All Van Types Handled',
            'Motorway & Local',
            'Business & Personal',
            'Safe Transport'
        ],
        process: [
            { step: 'Contact Us', detail: 'Call our 24/7 hotline for immediate van recovery assistance.' },
            { step: 'Rapid Deployment', detail: 'We dispatch a suitable recovery vehicle for your van type.' },
            { step: 'Safe Recovery', detail: 'We transport your van safely to your home, garage, or business.' }
        ],
        faqs: [
            { q: 'Do you provide 24/7 van recovery?', a: 'Yes, we operate around the clock to assist with van breakdowns and emergencies.' },
            { q: 'Can you recover large commercial vans?', a: 'Yes, we recover all types of vans, including panel and commercial vehicles.' },
            { q: 'Do you cover motorways?', a: 'Yes, our van recovery service covers M6, M5, M42, and surrounding routes.' },
            { q: 'Can you transport vans to garages or business locations?', a: 'Absolutely — we deliver safely to your preferred destination.' }
        ]
    },
    {
        slug: 'motorway-recovery',
        title: 'Motorway Recovery',
        description: 'Professional motorway recovery services in Birmingham and West Midlands. Fast, safe, and reliable assistance for motorway breakdowns.',
        longDescription: `Breaking down on a motorway can be dangerous and highly stressful. Fast action is essential to ensure your safety. Cheapest Car Recovery provides professional motorway recovery services in Birmingham and across the West Midlands, helping drivers safely leave busy motorways.

If you’re searching for "car recovery near me" or "car recovery service near me" because of a puncture or blowout, our local team can reach you fast and sort the problem on the spot.

Whether your engine fails, your vehicle overheats, or you’re involved in an accident, our experienced recovery team responds quickly to remove your vehicle safely and transport it to your chosen destination.

### Professional Motorway Recovery You Can Trust
Motorway breakdowns require experience and quick response. Cheapest Car Recovery operates fully equipped recovery vehicles designed to handle roadside and motorway situations safely.

Our motorway recovery service includes:
• Motorway breakdown recovery
• Hard shoulder recovery
• Accident recovery from motorways
• Emergency towing
• Transport to home or garage

We ensure safe vehicle loading while prioritising your personal safety.

### When Do You Need Motorway Recovery?
You may need motorway recovery if:
• Your vehicle breaks down on the hard shoulder
• Your engine overheats while driving
• You are involved in a motorway accident
• Your vehicle loses power while travelling
• Warning lights indicate serious failure

Staying on a motorway with a broken-down vehicle can be dangerous. Professional recovery ensures safe removal.

### Motorway Recovery Across Birmingham & West Midlands
We provide motorway recovery on major routes including:
• Birmingham
• Solihull
• M5
• M6
• M40
• M42

We also cover Birmingham and all nearby West Midlands areas.

### Why Choose Cheapest Car Recovery for Motorway Recovery?
• Fast motorway response
• Experienced recovery drivers
• Fully insured service
• Affordable pricing
• 24/7 availability

We understand motorway emergencies require urgency and professionalism.

### Call Us for Motorway Assistance
If you have broken down on a motorway, contact Cheapest Car Recovery immediately.`,
        image: motorwayRecoveryImg,
        benefits: [
            'Fast Motorway Response',
            'Experienced Drivers',
            'Fully Insured',
            'Affordable Pricing',
            '24/7 Availability'
        ],
        process: [
            { step: 'Safety Advice', detail: 'We advise you on where to stand safely while waiting.' },
            { step: 'Rapid Arrival', detail: 'We use GPS technology to locate you quickly on the motorway.' },
            { step: 'Safe Removal', detail: 'We load and remove your vehicle from the danger zone efficiently.' }
        ],
        faqs: [
            { q: 'How quickly can you reach me?', a: 'We aim for fast response times depending on traffic and location, especially within Birmingham and nearby areas.' },
            { q: 'Do you recover vehicles from motorways?', a: 'Yes, we provide safe and professional motorway breakdown recovery on M6, M5, M42, and surrounding routes.' },
            { q: 'Are you available 24/7?', a: 'Yes, our breakdown recovery service operates 24 hours a day, 7 days a week.' },
            { q: 'Can you recover vans as well as cars?', a: 'Yes, we recover cars, vans, and light commercial vehicles.' }
        ]
    },
    {
        slug: 'caravan-recovery',
        title: 'Caravan Recovery',
        description: 'Professional caravan recovery services across Birmingham and West Midlands. We transport caravans safely to your home, campsite, or repair centre.',
        longDescription: `Whether you’re enjoying a weekend getaway or a long holiday, a caravan breakdown can quickly turn a fun trip into a stressful situation. Cheapest Car Recovery provides professional caravan recovery services across Birmingham and the West Midlands, ensuring your caravan is transported safely and efficiently back to your home, campsite, or repair centre.

If you’re searching online for "car recovery near me" or "car recovery service near me", our local team is always ready to reach you quickly and get you moving again.

Our experienced team is trained to handle all types of caravans, providing secure and reliable recovery services in any situation — from minor mechanical faults to roadside emergencies.

### Professional Caravan Recovery You Can Trust
With Cheapest Car Recovery, caravan recovery is handled with precision and care. Our specialists use modern towing equipment to safely recover caravans without causing damage, whether you’re on a motorway, rural road, or urban street.

Our caravan recovery service includes:
• 24/7 emergency caravan recovery
• Safe towing of all types and sizes of caravans
• Transport from roadside, campsite, or motorway
• Local and long-distance recovery
• Delivery to home, garage, or holiday destination

No matter the location, your caravan is in safe hands.

### When Do You Need Caravan Recovery?
Professional caravan recovery is needed if:
• Your caravan has broken down while travelling
• Mechanical failure prevents towing
• You’re stranded on a motorway, A-road, or campsite
• Accidents or towing difficulties have left you stuck

Attempting to recover a caravan without professional equipment can cause damage or injury. Professional recovery ensures safety and peace of mind.

### Caravan Recovery Across Birmingham & West Midlands
We provide fast-response caravan recovery services throughout:
• Bromsgrove
• Banbury
• Shirley
• Telford
• Studley
• Marston Green

We also cover motorway recovery on:
• M6
• M5
• M42
• M40

With local expertise and modern recovery vehicles, we reach you quickly and transport your caravan safely.

### Why Choose Cheapest Car Recovery for Caravan Recovery?
Choosing the right caravan recovery service guarantees safety and efficiency.

• 24/7 availability for caravan emergencies
• Experienced and professional recovery drivers
• Safe towing and transport of all caravan types
• Transparent and affordable pricing
• Coverage across Birmingham & West Midlands

Cheapest Car Recovery is dedicated to providing professional, reliable caravan recovery services whenever you need them.

### Affordable & Reliable Caravan Recovery
Caravan breakdowns can be stressful and disruptive. Our cost-effective caravan recovery solutions ensure your vehicle is recovered safely and transported efficiently, minimising inconvenience.

If you’re searching for “caravan recovery near me”, “emergency caravan towing Birmingham”, or “caravan recovery West Midlands”, Cheapest Car Recovery is the trusted local choice.

### Call Us for Caravan Recovery
Don’t let a caravan breakdown ruin your trip. Contact Cheapest Car Recovery now for professional and safe caravan recovery services.`,
        image: 'https://i.pinimg.com/736x/83/3e/10/833e108202f9b0f236973d7f5038ab88.jpg',
        benefits: [
            '24/7 Caravan Recovery',
            'All Caravan Sizes',
            'Campsite & Roadside',
            'Safe Towing',
            'Nationwide Transport'
        ],
        process: [
            { step: 'Contact Us', detail: 'Call our 24/7 hotline for immediate caravan recovery.' },
            { step: 'Safe Securing', detail: 'We secure your caravan for safe transport using specialized equipment.' },
            { step: 'Destination Delivery', detail: 'We deliver your caravan to your home, campsite, or repair centre.' }
        ],
        faqs: [
            { q: 'Do you provide 24/7 caravan recovery?', a: 'Yes, our service operates around the clock to assist with caravan emergencies.' },
            { q: 'Can you recover large or touring caravans?', a: 'Absolutely — we recover all sizes and types of caravans safely.' },
            { q: 'Do you cover motorway locations?', a: 'Yes, we operate on M6, M5, M42, and surrounding routes.' },
            { q: 'Can you transport caravans to campsites or garages?', a: 'Yes, we deliver caravans safely to your chosen destination.' }
        ]
    },
    {
        slug: 'motorbike-recovery',
        title: 'Motorbike Recovery',
        description: 'Professional 24/7 motorbike recovery services here in Birmingham and across the West Midlands. Safe, secure, and fully insured transport for your motorcycle.',
        longDescription: `When your motorbike breaks down unexpectedly, it can quickly ruin your journey and leave you stranded. Cheapest Car Recovery provides professional 24/7 motorbike recovery services in Birmingham and across the West Midlands, ensuring your motorcycle is transported safely and securely.

If you’re searching online for "car recovery near me" or "car recovery service near me", our local team is always ready to reach you quickly and get you moving again.

Whether your bike won’t start, has been involved in an accident, or develops a mechanical issue while riding, our experienced recovery team is ready to respond quickly. We recover motorbikes from homes, roadsides, car parks, and motorways, delivering them safely to your home, garage, or chosen repair centre.

### Professional Motorbike Recovery You Can Trust
Cheapest Car Recovery specializes in safe and secure motorcycle transportation. Motorbikes require careful handling and correct strapping techniques to prevent damage during loading and transit. Our trained operators use proper equipment to ensure your bike remains fully protected.

Our motorbike recovery service includes:
• 24/7 emergency motorbike recovery
• Local and long-distance transport
• Accident-damaged bike recovery
• Secure loading and safe transportation
• Delivery to home, garage, or workshop

No matter the time or location, we ensure your motorbike is recovered professionally and without stress.

### When Do You Need Motorbike Recovery?
You may require motorbike recovery if:
• Your bike refuses to start
• You experience engine failure
• You are involved in a road accident
• Your motorcycle develops a serious mechanical fault
• You break down on a busy road or motorway

Attempting to move a faulty bike yourself can cause further damage. Calling Cheapest Car Recovery ensures safe and professional handling.

### Motorbike Recovery Across Birmingham & West Midlands
We provide fast-response motorbike recovery across:
• Birmingham
• Yardley
• Wolverhampton
• Walsall
• Nottingham
• Dudley

We also recover motorcycles from major routes including:
• M6
• M5
• M40
• M42

### Why Choose Cheapest Car Recovery for Motorbike Recovery?
• Fast response times
• Affordable and transparent pricing
• Experienced and trained recovery operators
• Fully insured vehicle transport
• 24/7 availability

We understand how important your motorbike is, and we treat every recovery with care and professionalism.

### Call Us for Motorbike Assistance
If your motorbike has broken down, don’t take risks. Contact Cheapest Car Recovery for safe and reliable motorbike recovery.`,
        image: motorbikeRecoveryImg,
        benefits: [
            '24/7 Emergency Service',
            'Safe & Secure Transport',
            'Accident Recovery',
            'Home & Garage Delivery',
            'Fully Insured'
        ],
        process: [
            { step: 'Contact Us', detail: 'Call our 24/7 hotline for immediate motorbike recovery.' },
            { step: 'Secure Loading', detail: 'We use specialist equipment to load and strap your bike safely.' },
            { step: 'Safe Transport', detail: 'We transport your motorcycle to your chosen destination without damage.' }
        ],
        faqs: [
            { q: 'How quickly can you reach me?', a: 'We aim for fast response times depending on traffic and location, especially within Birmingham and nearby areas.' },
            { q: 'Do you recover vehicles from motorways?', a: 'Yes, we provide safe and professional motorway breakdown recovery on M6, M5, M42, and surrounding routes.' },
            { q: 'Are you available 24/7?', a: 'Yes, our breakdown recovery service operates 24 hours a day, 7 days a week.' },
            { q: 'Can you recover vans as well as cars?', a: 'Yes, we recover cars, vans, and light commercial vehicles.' }
        ]
    },
    {
        slug: 'jump-start',
        title: 'Battery Jump Start',
        description: 'Professional 24/7 battery jump start services across Birmingham and West Midlands. We get you moving quickly and safely.',
        longDescription: `A dead or flat car battery can leave you stranded at the most inconvenient times — early in the morning, late at night, or in busy traffic. Cheapest Car Recovery provides professional 24/7 battery jump start services across Birmingham and the West Midlands, ensuring you get moving quickly and safely.

If you’re searching for "car recovery near me" or "car recovery service near me" after an accident, our experienced team is ready to respond fast and assist you right away.

Our expert technicians are equipped to provide fast, safe jump starts for cars, vans, and light commercial vehicles, helping you avoid delays and get back on the road without unnecessary stress.

### Professional Battery Jump Start You Can Rely On
With Cheapest Car Recovery, a dead battery is no longer a problem. Our trained team uses professional jump-start equipment to safely restart your vehicle, ensuring no damage to your battery or electrical system.

Our battery jump start service includes:
• 24/7 emergency battery jump start
• Assistance for cars, vans, and light commercial vehicles
• Safe roadside operations
• Quick response across city streets and motorways
• Advice on battery maintenance and replacement if needed

We ensure you can continue your journey safely and efficiently.

### When Do You Need a Battery Jump Start?
You may require a professional battery jump start if:
• Your vehicle won’t start due to a dead battery
• You left lights or electrical devices on overnight
• Extreme weather drained your battery
• Your battery is old or faulty
• You’re stranded on a motorway, street, or remote location

Attempting to jump-start your battery without professional knowledge can risk damage to your vehicle. Professional assistance ensures safety and peace of mind.

### Battery Jump Start Across Birmingham & West Midlands
We provide fast-response jump start services throughout:
• Birmingham
• Solihull
• Erdington
• Yardley
• Shirley
• Chelmsley Wood

We also provide motorway jump start services on:
• M6
• M5
• M42
• M40

Our local knowledge allows us to reach your location quickly, even in busy or challenging areas.

### Why Choose Cheapest Car Recovery for Battery Jump Start?
Choosing the right service ensures your vehicle is handled safely and professionally.

• 24/7 availability for battery emergencies
• Experienced and trained technicians
• Safe jump-start procedures for all vehicle types
• Transparent and affordable pricing
• Coverage across Birmingham & West Midlands

Cheapest Car Recovery is committed to providing fast, reliable battery jump start services whenever you need them.

### Affordable & Reliable Battery Assistance
Dead batteries can cause unexpected delays. Our cost-effective jump start service ensures you’re back on the road quickly without unnecessary costs or hassle. If a battery replacement is needed, our team can advise you on the best options.

If you’re searching for “battery jump start near me”, “emergency jump start Birmingham”, or “24 hour jump start West Midlands”, Cheapest Car Recovery is the trusted local choice.

### Call Us for Battery Jump Start
Don’t let a dead battery ruin your day. Contact Cheapest Car Recovery now for fast and professional battery jump start services.`,
        image: 'https://i.pinimg.com/736x/4d/de/8e/4dde8e62b577e42ef30f65d2b51edd4c.jpg',
        benefits: [
            '24/7 Emergency Jump Start',
            'Cars, Vans & Commercials',
            'Safe Roadside Ops',
            'Battery Health Advice',
            'Quick Response'
        ],
        process: [
            { step: 'Contact Us', detail: 'Call our 24/7 hotline for immediate battery assistance.' },
            { step: 'Rapid Response', detail: 'Our technician arrives quickly with professional jump-start equipment.' },
            { step: 'Safe Start', detail: 'We safely jump-start your vehicle and check the alternator output.' }
        ],
        faqs: [
            { q: 'Do you provide 24/7 battery jump start services?', a: 'Yes, we operate around the clock to assist with battery emergencies.' },
            { q: 'Can you jump-start vans and commercial vehicles?', a: 'Yes, our service covers cars, vans, and light commercial vehicles.' },
            { q: 'Do you provide motorway jump start services?', a: 'Absolutely — we cover M6, M5, M42, and surrounding routes.' },
            { q: 'Can you advise if my battery needs replacement?', a: 'Yes, our trained technicians can check your battery and provide advice on replacement if necessary.' }
        ]
    },
    {
        slug: 'flat-tyre',
        title: 'Flat Tyre',
        description: 'Fast, professional flat tyre assistance across Birmingham and the West Midlands, helping you get back on the road safely and efficiently.',
        longDescription: `A flat tyre can happen at the most inconvenient times — on the way to work, during a busy day, or even late at night. Cheapest Car Recovery provides fast, professional flat tyre assistance across Birmingham and the West Midlands, helping you get back on the road safely and efficiently.

If you’re searching for "car recovery near me" or "car recovery service near me" because of a puncture or blowout, our local team can reach you fast and sort the problem on the spot.

Our expert team is equipped to handle all types of vehicles, from cars and vans to light commercial vehicles, providing safe and reliable tyre support wherever you are.

### Professional Flat Tyre Assistance You Can Rely On
With Cheapest Car Recovery, flat tyre issues are resolved quickly and professionally. We understand that a punctured or damaged tyre can leave you stranded, so our team prioritises speed, safety, and convenience.

Our flat tyre assistance includes:
• Emergency on-site tyre repair or replacement
• Assistance for cars, vans, and light commercial vehicles
• Safe roadside operations
• Quick response across urban streets and motorways
• Transport to nearest garage if needed

No matter the location, we ensure your vehicle is handled with care.

### When Do You Need Flat Tyre Assistance?
Flat tyre services are essential in situations such as:
• Sudden tyre puncture on busy roads
• Slow leaks causing unsafe driving conditions
• Tyre blowouts or severe damage
• Stranded on motorways or city streets
• Vehicles that cannot be safely driven

Trying to drive on a flat or damaged tyre can cause further damage or accidents. Professional assistance keeps you and your vehicle safe.

### Flat Tyre Assistance Across Birmingham & West Midlands
We provide fast-response flat tyre assistance throughout:
• Lichfield
• Stourbridge
• Kingswinford
• Coventry
• Redditch
• Derby

We also cover motorways and major roads, including:
• M6
• M5
• M42
• M40

Our local expertise ensures we reach you quickly, even in busy or difficult locations.

### Why Choose Cheapest Car Recovery for Flat Tyre Assistance?
Choosing a reliable flat tyre service ensures safety, efficiency, and peace of mind.

• 24/7 availability for emergencies
• Professional, trained technicians
• Quick on-site tyre repairs or replacements
• Affordable and transparent pricing
• Safe handling on all types of roads and motorways

Cheapest Car Recovery is committed to providing dependable and professional flat tyre solutions whenever you need them.

### Affordable & Quick Tyre Assistance
We understand that tyre emergencies are stressful. That’s why we provide cost-effective, transparent, and high-quality service. Many common tyre issues are resolved on the spot, reducing delays and inconvenience.

If you’re searching for “flat tyre assistance near me”, “tyre repair Birmingham”, or “emergency tyre replacement West Midlands”, Cheapest Car Recovery is the trusted choice for quick, professional service.

### Call Us for Flat Tyre Assistance
Don’t let a flat tyre disrupt your day. Contact Cheapest Car Recovery now for fast, reliable, and safe flat tyre assistance.`,
        image: 'https://i.pinimg.com/736x/f4/15/86/f415863c4964f67ed036cc12c737ec4a.jpg',
        benefits: [
            '24/7 Availability',
            'On-Site Repair/Replace',
            'Cars, Vans & Commercials',
            'Safe Roadside Ops',
            'Quick Response'
        ],
        process: [
            { step: 'Contact Us', detail: 'Call our 24/7 hotline for immediate tyre assistance.' },
            { step: 'Rapid Arrival', detail: 'We reach you quickly, whether on a motorway or city street.' },
            { step: 'On-Site Fix', detail: 'We repair or replace your tyre on the spot, or transport you to a garage.' }
        ],
        faqs: [
            { q: 'Can you fix tyres on-site?', a: 'Yes, our team can repair or replace most tyres directly at the breakdown location.' },
            { q: 'Do you provide motorway flat tyre assistance?', a: 'Absolutely — we cover M6, M5, M42, and surrounding routes.' },
            { q: 'Are you available 24/7 for tyre emergencies?', a: 'Yes, we operate around the clock to provide fast support.' },
            { q: 'Can you help vans and commercial vehicles?', a: 'Yes, our flat tyre assistance covers cars, vans, and light commercial vehicles.' }
        ]
    },
    {
        slug: 'stuck-vehicle',
        title: 'Stuck Vehicle',
        description: 'Professional stuck vehicle recovery services across Birmingham and the West Midlands. We extract vehicles from mud, snow, sand, and ditches safely.',
        longDescription: `Getting your vehicle stuck in mud, snow, sand, or uneven terrain can be frustrating and potentially dangerous. Cheapest Car Recovery provides professional stuck vehicle recovery services across Birmingham and the West Midlands, helping you get back on the road safely and quickly.

If you’re searching for "car recovery near me" or "car recovery service near me" after an accident, our experienced team is ready to respond fast and assist you right away.

Our experienced team is equipped to recover cars, vans, and light commercial vehicles from challenging situations, whether it’s on city streets, rural areas, or motorways.

### Professional Stuck Vehicle Recovery You Can Rely On
With Cheapest Car Recovery, stuck vehicles are recovered efficiently and safely. Our team uses specialised equipment and professional techniques to ensure your vehicle is extracted without causing further damage.

Our stuck vehicle recovery service includes:
• 24/7 emergency recovery for stuck vehicles
• Recovery from mud, snow, sand, or uneven terrain
• Safe vehicle handling and extraction
• Assistance for cars, vans, and light commercial vehicles
• Transport to home, garage, or preferred location if required

No matter the difficulty of the situation, we ensure your vehicle is recovered safely.

### When Do You Need Stuck Vehicle Recovery?
You may require professional recovery if:
• Your vehicle is stuck in mud, snow, or sand
• You’re trapped on off-road or uneven terrain
• Your vehicle cannot be driven safely
• You are on a motorway or roadside and need extraction

Attempting to recover a stuck vehicle without professional help can lead to damage or personal injury. Professional recovery ensures safety for both you and your vehicle.

### Stuck Vehicle Recovery Across Birmingham & West Midlands
We provide fast-response recovery throughout:
• Warwick
• Kitts Green
• Motorway
• Stechford
• Peterborough
• Nottingham

We also offer motorway stuck vehicle recovery services on:
• M6
• M5
• M42
• M40

Our local knowledge ensures we reach challenging locations efficiently and safely.

### Why Choose Cheapest Car Recovery for Stuck Vehicle Recovery?
Choosing the right recovery service is essential for safety and efficiency.

• 24/7 availability for emergencies
• Trained and professional recovery technicians
• Safe and careful vehicle extraction
• Affordable and transparent pricing
• Coverage across Birmingham & West Midlands

Cheapest Car Recovery is committed to providing fast, professional, and reliable recovery for stuck vehicles whenever needed.

### Affordable & Reliable Vehicle Extraction
Being stuck doesn’t have to be stressful or expensive. We provide cost-effective recovery solutions using modern equipment and experienced staff to ensure safe extraction.

If you’re searching for “stuck vehicle recovery near me”, “mud or snow recovery Birmingham”, or “emergency vehicle extraction West Midlands”, Cheapest Car Recovery is the trusted choice for professional and reliable service.

### Call Us for Stuck Vehicle Recovery
If your vehicle is stuck, don’t risk further damage. Contact Cheapest Car Recovery now for fast and professional stuck vehicle recovery.`,
        image: 'https://i.pinimg.com/736x/f2/73/ce/f273ce277f136d707b35ee5539a7ea19.jpg',
        benefits: [
            '24/7 Emergency Recovery',
            'Mud, Snow, Sand Extraction',
            'Safe Handling',
            'Cars & Vans',
            'Affordable Pricing'
        ],
        process: [
            { step: 'Contact Us', detail: 'Call our 24/7 hotline for immediate stuck vehicle recovery.' },
            { step: 'Rapid Response', detail: 'We reach your location quickly, even in difficult terrain.' },
            { step: 'Safe Extraction', detail: 'We use specialized equipment to recover your vehicle without damage.' }
        ],
        faqs: [
            { q: 'Do you provide 24/7 stuck vehicle recovery?', a: 'Yes, our service is available around the clock, including weekends and holidays.' },
            { q: 'Can you recover vehicles from difficult terrain?', a: 'Absolutely — we recover vehicles stuck in mud, snow, sand, or uneven surfaces.' },
            { q: 'Do you cover motorways?', a: 'Yes, we operate on M6, M5, M42, and surrounding routes.' },
            { q: 'Can you recover vans and commercial vehicles?', a: 'Yes, our service covers cars, vans, and light commercial vehicles.' }
        ]
    },
    {
        slug: 'refueling',
        title: 'Refueling',
        description: 'Professional emergency refueling services across Birmingham and West Midlands. We deliver petrol or diesel directly to your location 24/7.',
        longDescription: `Running out of fuel unexpectedly can be stressful, dangerous, and inconvenient — whether it happens in the city, on a busy road, or on a motorway. Cheapest Car Recovery provides professional emergency refueling services across Birmingham and the West Midlands, ensuring you’re never left stranded due to an empty tank.

If you’re searching online for "car recovery near me" or "car recovery service near me", our local team is always ready to reach you quickly and get you moving again.

Our trained team delivers fuel directly to your location, helping you get back on the road quickly and safely. We cover cars, vans, and light commercial vehicles, providing fast and reliable refuelling assistance whenever you need it.

### Professional Emergency Refueling You Can Trust
With Cheapest Car Recovery, emergency refueling is simple and stress-free. Our experts arrive with the correct fuel type and equipment to safely refill your vehicle on-site, preventing delays and hazards associated with running out of fuel.

Our emergency refueling service includes:
• On-site fuel delivery for cars, vans, and light commercial vehicles
• Petrol, diesel, and approved fuel types
• Safe and professional refueling at roadside or motorway
• 24/7 availability for emergencies
• Quick response across urban and motorway locations

No matter the time or place, our team ensures you can continue your journey safely.

### When Do You Need Emergency Refueling?
You may require professional emergency refueling if:
• Your vehicle runs out of fuel unexpectedly
• You’re stranded on a motorway, busy road, or remote location
• Fuel gauges fail to warn you in time
• You need safe and legal fuel delivery without risk

Trying to drive on empty can damage your vehicle and create dangerous situations. Professional emergency refueling keeps you safe and on schedule.

### Emergency Refueling Across Birmingham & West Midlands
We provide fast-response fuel delivery and refueling throughout:
• Halesowen
• Oldbury
• Northampton
• Bristol
• Leicester
• Stoke-on-Trent

We also cover motorway locations such as:
• M6
• M5
• M42
• M40

With local knowledge and quick navigation, we reach your location efficiently, even during peak traffic.

### Why Choose Cheapest Car Recovery for Emergency Refueling?
Selecting a professional refueling service ensures safety, reliability, and convenience.

• Fast response and on-site fuel delivery
• Trained and professional staff
• Safe handling of fuel and vehicles
• 24/7 availability across Birmingham & West Midlands
• Transparent and affordable pricing

Cheapest Car Recovery is committed to providing dependable emergency refueling services whenever you need them.

### Affordable & Reliable Fuel Delivery
Fuel emergencies don’t need to be expensive or stressful. Our service is affordable, fast, and safe, ensuring you can continue your journey without worry. Most emergency refueling calls are resolved on-site in minutes.

If you’re searching for “emergency fuel delivery near me”, “refueling service Birmingham”, or “24 hour fuel delivery West Midlands”, Cheapest Car Recovery is the trusted choice for professional and reliable service.

### Call Us for Emergency Refueling
If your vehicle has run out of fuel, don’t wait or risk unsafe situations. Contact Cheapest Car Recovery now for fast and professional emergency refueling services.`,
        image: 'https://i.pinimg.com/736x/58/91/86/589186477b229b344968501b2d13a0e5.jpg',
        benefits: [
            '24/7 Fuel Delivery',
            'Petrol & Diesel',
            'Roadside & Motorway',
            'Fast Response',
            'Safe Handling'
        ],
        process: [
            { step: 'Contact Us', detail: 'Call our 24/7 hotline and specify your fuel type (Petrol/Diesel).' },
            { step: 'Rapid Delivery', detail: 'We dispatch a vehicle with your fuel to your location immediately.' },
            { step: 'Refill & Go', detail: 'We fill your tank safely so you can continue your journey.' }
        ],
        faqs: [
            { q: 'Do you provide fuel delivery 24/7?', a: 'Yes, our emergency refueling service operates around the clock.' },
            { q: 'Can you deliver both petrol and diesel?', a: 'Yes, we provide safe delivery of all approved fuel types.' },
            { q: 'Do you cover motorway locations?', a: 'Absolutely — we operate on M6, M5, M42, and surrounding routes.' },
            { q: 'Can you refuel vans and commercial vehicles?', a: 'Yes, our service covers cars, vans, and light commercial vehicles.' }
        ]
    },
    {
        slug: 'mobile-mechanic',
        title: 'Mobile Mechanic',
        description: 'Professional mobile mechanic services across Birmingham and West Midlands. We bring expert vehicle repairs directly to your home, work, or roadside.',
        longDescription: `When your vehicle develops a fault or requires urgent repair, waiting for a garage visit can be inconvenient and time-consuming. Cheapest Car Recovery provides professional mobile mechanic services across Birmingham and the West Midlands, bringing expert vehicle repairs directly to your location — home, workplace, or roadside.

If you’re searching for "car recovery near me" or "car recovery service near me" because of a puncture or blowout, our local team can reach you fast and sort the problem on the spot.

Our experienced mobile mechanics handle cars, vans, and light commercial vehicles, providing fast, reliable, and professional repairs without the need to tow your vehicle to a garage.

### Professional Mobile Mechanic Services You Can Trust
With Cheapest Car Recovery, vehicle repairs are handled efficiently and safely. Our mobile mechanics carry essential tools and parts to fix common problems on-site, saving you time and providing peace of mind.

Our mobile mechanic service includes:
• On-site vehicle diagnostics and repairs
• Engine, electrical, and mechanical fault repairs
• Flat tyre changes, battery replacements, and minor servicing
• Emergency repairs for roadside breakdowns
• Professional advice and preventive maintenance tips

No matter the issue, our team ensures your vehicle is restored safely and efficiently.

### When Do You Need a Mobile Mechanic?
Professional mobile mechanic services are ideal if:
• Your vehicle breaks down and cannot reach a garage
• You need urgent repairs at home, work, or roadside
• Minor faults prevent safe driving
• You require diagnostic checks for warning lights
• You want fast, convenient, on-site servicing

Avoid unnecessary towing or delays — mobile mechanics provide expert solutions wherever your vehicle is.

### Mobile Mechanic Services Across Birmingham & West Midlands
We provide fast-response mobile mechanic services throughout:
• Birmingham
• Sheldon
• Tamworth
• Bristol
• Erdington
• Shardend

We also offer support for vehicles stranded on motorways, including:
• M6
• M5
• M42
• M40

Our local knowledge ensures we reach your location quickly, even in high-traffic areas.

### Why Choose Cheapest Car Recovery for Mobile Mechanic Services?
Choosing a professional mobile mechanic service ensures efficiency, safety, and reliability.

• 24/7 availability for emergency repairs
• Experienced and fully qualified mechanics
• On-site repairs for cars, vans, and light commercial vehicles
• Transparent and affordable pricing
• Coverage across Birmingham & West Midlands

Cheapest Car Recovery is committed to providing fast, reliable, and professional mobile mechanic services whenever you need them.

### Affordable & Reliable Mobile Vehicle Repairs
Vehicle issues can be disruptive and stressful. Our cost-effective mobile mechanic service ensures fast on-site repairs, preventing delays and unnecessary towing. For more complex issues, our team can advise on the best course of action.

If you’re searching for “mobile mechanic near me”, “emergency vehicle repair Birmingham”, or “mobile car repair West Midlands”, Cheapest Car Recovery is the trusted local choice for expert and professional service.

### Call Us for Mobile Mechanic Services
Don’t let vehicle faults slow you down. Contact Cheapest Car Recovery now for fast, professional, and convenient mobile mechanic services.`,
        image: 'https://i.pinimg.com/736x/17/e5/77/17e5772ed7f420d364e21ecd2f61a0c9.jpg',
        benefits: [
            'On-Site Repairs',
            'Diagnostics & Fault Finding',
            'No Towing Needed',
            'Qualified Mechanics',
            'Convenient Service'
        ],
        process: [
            { step: 'Contact Us', detail: 'Call us to describe your vehicle issue or symptoms.' },
            { step: 'Mobile Repair', detail: 'Our mobile mechanic comes to your location with tools and parts.' },
            { step: 'Get Moving', detail: 'We repair your vehicle on-site so you can continue your day.' }
        ],
        faqs: [
            { q: 'Do you provide 24/7 mobile mechanic services?', a: 'Yes, we operate around the clock for emergency vehicle repairs.' },
            { q: 'Can you repair vans and commercial vehicles on-site?', a: 'Yes, our mobile mechanics cover cars, vans, and light commercial vehicles.' },
            { q: 'Do you provide motorway support?', a: 'Absolutely — we offer assistance on M6, M5, M42, and surrounding routes.' },
            { q: 'Can minor repairs and diagnostics be done on-site?', a: 'Yes, most minor faults, tyre changes, battery replacements, and diagnostics are handled on-site efficiently.' }
        ]
    }
];
